var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoAudio = function SvgVideoAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.639 10.237a1.501 1.501 0 0 1-.877-.876l-2.761-7.36h-17.5A1.5 1.5 0 0 0 5 3.5v37A1.5 1.5 0 0 0 6.5 42h27a1.5 1.5 0 0 0 1.5-1.502V13l-7.361-2.762Z",
    fill: "#6544F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fillOpacity: 0.35,
    fill: "#6544F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.002 21c-.52 0-1.002.416-1.002 1.001v9.998a1.001 1.001 0 0 0 1.53.848l8-4.999a1 1 0 0 0 0-1.696l-8-4.998a.986.986 0 0 0-.528-.154m.002 1.004L25 27l-8 4.999.004-9.995",
    fill: "#FFF"
  }))));
};
export default SvgVideoAudio;